import {PermissionCollection} from "../../../collections/Permissions";

export class AnalyticsPermissionCollection extends PermissionCollection {
    canCreateNewAnalyticsGroup = this.generatePermissionFunction('app', 'analytics', 'create');
    canViewAnalyticsGroup = this.generatePermissionFunction('analytics', null, 'view');
    canModifyAnalyticsGroup = this.generatePermissionFunction('analytics', null, 'modify');
    canDeleteAnalyticsGroup = this.generatePermissionFunction('analytics', null, 'delete');
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/analytics/collections/AnalyticsPermissions.ts